import React from 'react';
import { AwardIcon, BellIcon, BookOpenIcon, BriefcaseIcon, BuildingIcon, CalendarDaysIcon, DatabaseIcon, DownloadIcon, EyeIcon, GraduationCapIcon, HeartIcon, HomeIcon, KeyRoundIcon, LanguagesIcon, LockIcon, MapPinIcon, MessageSquareIcon, ShieldCheckIcon, SlidersHorizontalIcon, SparklesIcon, StoreIcon, TargetIcon, TrashIcon, UserIcon, UsersIcon, WalletIcon } from 'lucide-react';

/**
 * One icon family, one mapping.
 *
 * Every profile surface asks for an icon BY MEANING — `academic`, `wallet`,
 * `privacy` — rather than importing a glyph directly. That is what keeps the
 * iconography coherent: a concept has exactly one icon across the page, and
 * changing it is one edit here rather than a search through components.
 *
 * Lucide is the platform's existing icon library, so nothing new is introduced.
 * Emoji and Unicode symbols are never used as interface icons.
 */
export type ProfileIconKey = 'academic' | 'campus' | 'wallet' | 'housing' | 'opportunities' | 'marketplace' | 'community' | 'events' | 'privacy' | 'security' | 'password' | 'sessions' | 'data' | 'download' | 'delete' | 'notifications' | 'bio' | 'interests' | 'skills' | 'lookingFor' | 'languages' | 'location' | 'identity' | 'verified' | 'reputation' | 'preferences' | 'messages' | 'people' | 'visibility' | 'joined';
const ICONS: Record<ProfileIconKey, React.ComponentType<{
  className?: string;
}>> = {
  academic: GraduationCapIcon,
  campus: BuildingIcon,
  wallet: WalletIcon,
  housing: HomeIcon,
  opportunities: BriefcaseIcon,
  marketplace: StoreIcon,
  community: UsersIcon,
  events: CalendarDaysIcon,
  privacy: EyeIcon,
  security: ShieldCheckIcon,
  password: KeyRoundIcon,
  sessions: LockIcon,
  data: DatabaseIcon,
  download: DownloadIcon,
  delete: TrashIcon,
  notifications: BellIcon,
  bio: UserIcon,
  interests: HeartIcon,
  skills: SparklesIcon,
  lookingFor: TargetIcon,
  languages: LanguagesIcon,
  location: MapPinIcon,
  identity: UserIcon,
  verified: ShieldCheckIcon,
  reputation: AwardIcon,
  preferences: SlidersHorizontalIcon,
  messages: MessageSquareIcon,
  people: UsersIcon,
  visibility: EyeIcon,
  joined: BookOpenIcon
};
export function ProfileIcon({
  name,
  className = 'h-4 w-4'
}: {
  name: ProfileIconKey;
  className?: string;
}) {
  const Glyph = ICONS[name];
  return <Glyph className={className} data-id="element-12315" data-mp="3j799ek1ius18" />;
}